
import { Box, Typography } from "@mui/material"
import { useIsMobileView } from "../../utils/responsive";
import { AccountsList } from "../accounts/account-list";


export const AccountsPage = () => {
    const isMobileView = useIsMobileView();
    return (
        <Box paddingX={isMobileView ? 2 : 10} marginTop={2} paddingBottom={8}>
        <AccountsList></AccountsList>
    </Box>
)
}